import { render } from "./message-tip.vue?vue&type=template&id=54b2b3c4&scoped=true&ts=true"
import script from "./message-tip.vue?vue&type=script&lang=ts"
export * from "./message-tip.vue?vue&type=script&lang=ts"

import "./message-tip.vue?vue&type=style&index=0&id=54b2b3c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b2b3c4"]])

export default __exports__